import './NotAuthorizedView.css'

export function NotAuthorizedView() {
  return (
    <div className="not-authorized-container">
      <div className="not-authorized-card" role="alert">
        <div className="not-authorized-icon" aria-hidden="true">&#x26D4;</div>
        <h1 className="not-authorized-title">Not authorized</h1>
        <p className="not-authorized-body">
          Your account does not have platform-admin access. Contact your system
          administrator if you believe this is an error.
        </p>
        <a href="/auth/logout" className="not-authorized-link">
          Sign out
        </a>
      </div>
    </div>
  )
}
